import { useEffect, useState } from "react"
import "./formulario-consulta-detalle.css"
// import ReactQuill, { Quill } from "react-quill";
import { useTranslation } from "react-i18next"
import "react-quill/dist/quill.bubble.css"
import store from "../../../../storeClient"
import ConsultasClient from "../../../api/consultas"

const ReactQuill =
  typeof window === "object" ? require("react-quill") : () => false

  
const ConsultaDetalle = (props) => {
  const { t } = useTranslation()
  const [banner, setBanner] = useState()
  const [nombre, setNombre] = useState("")
  const [email, setEmail] = useState("")
  const [telefono, setTelefono] = useState("")
  const [comentarios, setComentarios] = useState("")
  const { token } = store.getState().applicationState
  const empresaId = store.getState().applicationState.applicationId
  const nombreAgencia = store.getState().applicationState.nombre
  const paisId = store.getState().applicationState.paisId
  const emailAgencia =
    store.getState().applicationState.templateData?.header.emailContacto
  const [consulta, setConsulta] = useState({
    estadoConsulta: "",
  })
  const handleNombreChange = (event) => {
    setNombre(event.target.value)
  }

  const handleEmailChange = (event) => {
    setEmail(event.target.value)
  }

  const handleTelefonoChange = (event) => {
    setTelefono(event.target.value)
  }

  const handleComentariosChange = (event) => {
    setComentarios(event.target.value)
  }

  useEffect(() => {
    const rawBanners = JSON.parse(localStorage.getItem("banners"))
    let bannerList = []
    rawBanners.forEach((item) => {
      item.banner.forEach((banner) => {
        bannerList.push(banner)
      })
    })

    const filteredBanner = bannerList.find(
      (banner) => banner.id === Number(props.match.params.id)
    )
    setBanner(filteredBanner)
  }, [])

  const enviarConsulta = (event) => {
    event.preventDefault()
    let data = {
      nombre: nombre,
      email: email,
      comentarios: comentarios,
      agenciaId: empresaId,
      nombreAgencia: nombreAgencia,
      paisId: paisId,
      emailAgencia: emailAgencia,
      bannerId: banner.id,
      bannerTitle: banner.title,
      bannerDescription: banner.description,
      telefono,
      totalDias: 0,
      totalAdultos: 0,
      totalNinos: 0,
      mes: "",
      year: 0,
      apellido: "",
      destino: "",
      id: 0,
      estado: {
        id: 1,
      },
      tipoConsulta: "banners",
      banner: {
        id: banner.id,
      },
    }
    ConsultasClient.consultaMarcaBlanca(data, token).then((res) => {
      if (res.status === 201) {
        setConsulta({
          estadoConsulta: "enviado",
        })
        data.id = res.data.id
        ConsultasClient.enviarMailConsulta(data, token).then((res) => {
          if (res.status === 201) {
            console.log("Email Sent")
          } else {
            console.error("EMAIL - Error")
          }
        })
        alert("La consulta se envió correctamente")
        resetForm()
      } else {
        setConsulta({
          estadoConsulta: "error",
        })
        alert("La consulta no se pudo enviar")
      }
    })
  }

  const resetForm = () => {
    setNombre("")
    setEmail("")
    setTelefono("")
    setComentarios("")
  }

  return banner ? (
    <div className="container-consult">
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div>
          <h1 className="text-3xl font-bold text-gray-700 mb-2">
            {banner.title}
          </h1>
          <h2 className="text-lg font-bold text-gray-600">
            {banner.description}
          </h2>
        </div>
      </div>
      <div className="col-span-2">
        <ReactQuill value={banner.detalle} readOnly={true} theme={"bubble"} />
      </div>
      <form
        onSubmit={enviarConsulta}
        className="container-consult__detalle-form"
      >
        <h2 className="text-lg font-bold consulta-title c mb-2">
          {t("requestForm.requestTitle")}
        </h2>
        <div className="grid grid-cols-12 gap-4 mb-4">
          <div className="col-span-12 md:col-span-4">
            <div className="form-group">
              <div className="clearfix" />
              <span className="block text-gray-700 text-sm font-bold mb-2">
                {t("requestForm.name")} (*)
              </span>
              <input
                id="nombre"
                onChange={handleNombreChange}
                value={nombre}
                name="nombre"
                type="text"
                maxLength={50}
                className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
                required
              />
            </div>
          </div>
          <div className="col-span-12 md:col-span-4">
            <div className="form-group">
              <span className="block text-gray-700 text-sm font-bold mb-2">
                E-mail (*)
              </span>
              <input
                id="email"
                onChange={handleEmailChange}
                value={email}
                name="email"
                type="email"
                maxLength={50}
                className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
                required
              />
            </div>
          </div>
          <div className="col-span-12 md:col-span-4">
            <div className="form-group">
              <span className="block text-gray-700 text-sm font-bold mb-2">
                {t("requestForm.phone")}
              </span>
              <input
                id="telefono"
                onChange={handleTelefonoChange}
                value={telefono}
                name="telefono"
                type="number"
                maxLength={50}
                className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
              />
            </div>
          </div>
        </div>
        <div className="my-2">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="comentarios"
          >
            {t("requestForm.message")} (*)
          </label>
          <textarea
            id="comentarios"
            onChange={handleComentariosChange}
            value={comentarios}
            name="comentarios"
            className="h-36 shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight w-full"
            rows="5"
            placeholder={t("requestForm.commentsPlaceholder")}
            required
          />
        </div>
        <div className="flex">
          <button
            type="submit"
            className="ml-auto border border-blue-200 consulta-title transition duration-300 hover:bg-blue-100 font-semibold py-2 px-8 rounded focus:outline-none"
          >
            {t("requestForm.send")}
          </button>
        </div>
      </form>
    </div>
  ) : (
    <div />
  )
}

export default ConsultaDetalle
